import React from 'react'

const MediaUploadProgressBar = (props) => {

  return (
    <div className="progress mt-2">
    <div className="progress-bar progress-bar-striped bg-success progress-bar-animated" role="progressbar" aria-valuenow={props.progress} aria-valuemin="0" aria-valuemax="100" style={{ width: `${props.progress}%` }}>
        {props.progress}%
    </div>
</div>
  )
}

export default MediaUploadProgressBar;